export type PageMeta = {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
};

const DEFAULT_PAGE_META: PageMeta = {
  title: "Формы",
  ogTitle: "Формы",
};

function upsertMetaElement(
  selector: string,
  createAttributes: Record<string, string>,
  content: string,
): void {
  if (!content.trim()) {
    document.head.querySelector(selector)?.remove();
    return;
  }

  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    for (const [name, value] of Object.entries(createAttributes)) {
      element.setAttribute(name, value);
    }
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

export function applyPageMeta(meta: PageMeta): void {
  const title = meta.title?.trim();
  if (title) {
    document.title = title;
  }

  const ogTitle = (meta.ogTitle ?? meta.title)?.trim();
  if (ogTitle) {
    upsertMetaElement(
      'meta[property="og:title"]',
      { property: "og:title" },
      ogTitle,
    );
    upsertMetaElement(
      'meta[name="twitter:title"]',
      { name: "twitter:title" },
      ogTitle,
    );
  }

  const ogDescription = (meta.ogDescription ?? meta.description)?.trim();
  if (ogDescription) {
    upsertMetaElement(
      'meta[name="description"]',
      { name: "description" },
      ogDescription,
    );
    upsertMetaElement(
      'meta[property="og:description"]',
      { property: "og:description" },
      ogDescription,
    );
    upsertMetaElement(
      'meta[name="twitter:description"]',
      { name: "twitter:description" },
      ogDescription,
    );
  } else {
    document.head.querySelector('meta[name="description"]')?.remove();
    document.head.querySelector('meta[property="og:description"]')?.remove();
    document.head.querySelector('meta[name="twitter:description"]')?.remove();
  }

  const ogUrl = meta.ogUrl?.trim();
  if (ogUrl) {
    upsertMetaElement('meta[property="og:url"]', { property: "og:url" }, ogUrl);
  } else {
    document.head.querySelector('meta[property="og:url"]')?.remove();
  }
}

export function resetPageMeta(meta: PageMeta = DEFAULT_PAGE_META): void {
  applyPageMeta(meta);
}
